const keys = {
    "APP_ID": "3eb197ba",
    "APP_KEY": "af17608dba61eb36c0c7fde5247c7459"
}

export default keys